import type { AdminTranslateFn } from "../i18n/getAdminT";
import type { EventContentLevelRow } from "./aggregateEventContentOverview";

const GAME_MODALITIES = new Set([
  "LEVEL_MODALITY_QUIZ",
  "LEVEL_MODALITY_TREASURE_HUNT",
  "LEVEL_MODALITY_TOWER_CLIMB",
  "LEVEL_MODALITY_MAZE",
]);

export function modalityLabel(modality: string, t: AdminTranslateFn): string {
  if (modality === "LEVEL_MODALITY_STORY") {
    return t("eventContent.modalities.story");
  }
  if (modality === "LEVEL_MODALITY_QUIZ") {
    return t("eventContent.modalities.quiz");
  }
  if (modality === "LEVEL_MODALITY_TREASURE_HUNT") {
    return t("eventContent.modalities.treasureHunt");
  }
  if (modality === "LEVEL_MODALITY_TOWER_CLIMB") {
    return t("eventContent.modalities.towerClimb");
  }
  if (modality === "LEVEL_MODALITY_MAZE") {
    return t("eventContent.modalities.maze");
  }
  if (modality === "LEVEL_MODALITY_REWARD") {
    return t("eventContent.modalities.reward");
  }
  return modality;
}

function difficultyLabel(
  difficulty: string | undefined,
  t: AdminTranslateFn
): string | undefined {
  if (difficulty === "LEVEL_DIFFICULTY_NORMAL") {
    return t("eventContent.difficulties.normal");
  }
  if (difficulty === "LEVEL_DIFFICULTY_HARD") {
    return t("eventContent.difficulties.hard");
  }
  if (difficulty === "LEVEL_DIFFICULTY_SUPER_HARD") {
    return t("eventContent.difficulties.superHard");
  }
  return undefined;
}

function playFormatLabel(
  playFormat: string | undefined,
  t: AdminTranslateFn
): string {
  if (playFormat === "PLAY_FORMAT_TEAM") {
    return t("eventContent.playFormats.team");
  }
  return t("eventContent.playFormats.solo");
}

export function levelDisplayName(
  level: Pick<
    EventContentLevelRow,
    "modality" | "difficulty" | "playFormat" | "storyTitle"
  >,
  t: AdminTranslateFn
): string {
  if (level.modality === "LEVEL_MODALITY_STORY") {
    const title = level.storyTitle?.trim();
    return title || t("eventContent.modalities.story");
  }
  if (level.modality === "LEVEL_MODALITY_REWARD") {
    return t("eventContent.modalities.reward");
  }
  if (!GAME_MODALITIES.has(level.modality)) {
    return modalityLabel(level.modality, t);
  }

  const parts = [modalityLabel(level.modality, t)];
  parts.push(
    difficultyLabel(level.difficulty, t) ?? t("eventContent.difficulties.normal")
  );
  parts.push(playFormatLabel(level.playFormat, t));
  return parts.join(" · ");
}
